import * as yup from "yup";
import { VALIDATION_REGEX } from "utils/constants";
import i18next from "config/i18next";
import { AccountSchemaParams } from "pages/detailPicker/types";
import { validateFiscalNumber } from "utils/validations";
const requiredMessage = i18next.t("validations:required");

const requiredString = yup.string().required(requiredMessage);
const optionalString = yup.string().optional();
const requiredObject = yup.object().required(requiredMessage);
const optionalObject = yup.object().optional();

export const accountingDataMX = ({
  approve,
  duplicatedFiscalNumber,
}: AccountSchemaParams) =>
  yup.object({
    account: yup.object({
      number: yup
        .string()
        .concat(requiredString)
        .min(18, i18next.t("account:invalidBank"))
        .matches(
          VALIDATION_REGEX.regNumber,
          i18next.t("validations:numbersOnly")
        ),
      bank:
        approve ? requiredObject.nullable() : optionalObject.nullable(),
    }),
    fiscalNumber: yup
      .string()
      .nullable()
      .matches(VALIDATION_REGEX.regRFC, i18next.t("validations:invalidFormat"))
      .test(
        "duplicatedFiscalNumber",
        i18next.t("account:fiscalNumberDuplicated"),
        () => !duplicatedFiscalNumber
      )
      .test("requiredFiscalNumberIfSAP", "", validateFiscalNumber),
    address: yup.object({
      street: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .matches(
          VALIDATION_REGEX.regStreet,
          i18next.t("account:formatAddressError")
        ),
      streetNumber: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .matches(
          VALIDATION_REGEX.regStreet,
          i18next.t("account:formatAddressError")
        ),
      postalCode: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .min(5, i18next.t("account:cpError"))
        .matches(
          VALIDATION_REGEX.regNumber,
          i18next.t("validations:numbersOnly")
        ),
      locality: yup
        .string()
        .concat(approve ? requiredString : optionalString)
        .matches(
          VALIDATION_REGEX.regStreet,
          i18next.t("account:formatAddressError")
        ),
      province: approve ? requiredObject.nullable() : optionalObject.nullable(),
    }),
  });
